import { render, staticRenderFns } from "./Ano.vue?vue&type=template&id=36e7c520"
import script from "./Ano.vue?vue&type=script&lang=js"
export * from "./Ano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports